<ng-container>
    @switch (Scope.mode) {

        @case (PaymentSourceMode.Add) {
            @if (!loading) {
                <div class="d-flex justify-content-between align-content-center padding-bottom-24">
                    <ng-content select="[label]"></ng-content>
                    <ng-container *ngTemplateOutlet="addButton"></ng-container>
                </div>
            }

            <div class="d-flex flex-column single-column-row gap-3" [attr.data-sb-qa]="'payment-methods-list-draggable'" [ngClass]="{'w-50': !isMobile, 'w-100': isMobile}">
                <lib-list *ngFor="let paymentSource of paymentSources; index as i" [listMode]="ListMode.None">
                    <lib-list-item-row>
                        <div class="d-flex justify-content-between p-2" [ngClass]="{'flex-column':isMobile}">
                            <div [ngClass]="{'d-flex justify-content-between': isMobile}">
                                <div class="d-flex gap-3 align-items-center">
                                    <lib-icon *ngLet="(paymentSource | paymentIssuerIcon) as icon" [icon]="icon.Icon" [size]="IconSize.Large"></lib-icon>
                                    <p class="typography-label-large" data-clarity-mask="true" [attr.data-sb-qa]="'payment-source-issuer'">{{paymentSource.Issuer}}</p>
                                </div>
                                @if (isMobile) {
                                    <div>
                                        <ng-container *ngTemplateOutlet="menuButton; context: {$implicit: paymentSource, i: i}"></ng-container>
                                    </div>
                                }
                            </div>
                            <div  class="d-flex gap-3 " [ngClass]="{'align-items-center': !isMobile}">
                                @if (paymentSource | method: FindFirstVerifiedSource) {
                                    <lib-status-label [kind]="StatusKind.Default">
                                        <ng-container label i18n="@@CommonDefault">Default</ng-container>
                                    </lib-status-label>
                                }
                                @if (paymentSource.AutoPay && paymentSource.IsVerified) {
                                    <lib-status-label [kind]="StatusKind.Success">
                                        <ng-container label i18n="@@CommonPaymentSourcesAutoPayOn">
                                            Auto Pay Enabled
                                        </ng-container>
                                    </lib-status-label>
                                }
                                @if (!paymentSource.IsVerified) {
                                    <lib-status-label [kind]="StatusKind.Danger">
                                        <ng-container label i18n="@@CommonUnverifiedLabel">Unverified</ng-container>
                                    </lib-status-label>
                                }
                                @if (!isMobile) {
                                    <ng-container *ngTemplateOutlet="menuButton; context: {$implicit: paymentSource, i: i}"></ng-container>
                                }
                            </div>
                        </div>
                    </lib-list-item-row>
                    <lib-list-item-row>
                        <div class="d-flex gap-5" [attr.data-sb-qa]="'payment-source-number-and-expiry'">
                            <p class="typography-label-medium" data-clarity-mask="true">{{ paymentSource.DisplayText }}</p>
                            @if (paymentSource.Type === PaymentSourceType.CreditCard) {
                                <p class="typography-label-medium" data-clarity-mask="true">exp {{ paymentSource.ExpiryDate! | method: FormatExpiry }}</p>
                            }
                        </div>
                    </lib-list-item-row>
                </lib-list>
            </div>
        }
        @case (PaymentSourceMode.Payment) {
            <div class="single-column-row" [attr.data-sb-qa]="'payment-methods-list'">
                <div [ngClass]="{'payment-source-item-selected': selectedPaymentSource?.ID === paymentSource.ID}" class="my-2 py-2 px-4 payment-source-item" *ngFor="let paymentSource of paymentSources;  index as i" (click)="PaymentSourceSelected(paymentSource)">
                    <ng-container *ngTemplateOutlet="paymentSourceTemplate; context:{$implicit: paymentSource | method: CreateExtendedItem : i}"></ng-container>
                </div>
            </div>
        }

    }
</ng-container>

@if (!loading && isEmptyState) {
    <lib-empty-state
        qaTag="payment-sources-empty-state"
        [emptyStateGraphic]="EmptyStateGraphic.Invoices"
        [size]="isMobile? EmptyStateSize.Medium: EmptyStateSize.Large">
        <ng-container emptyStateText i18n="@@Common_NoPaymentMethods_Title">No payment methods yet</ng-container>
        <ng-container emptyStateDescription i18n="@@Common_NoPaymentMethods_Description">Payment methods on file will appear here</ng-container>
    </lib-empty-state>
}

<ng-template #addButton>
    <lib-button
        [kind]="Scope.context === PaymentContext.TeacherPortal ? ButtonKind.Secondary : ButtonKind.Primary"
        [prefixIcon]="Icon.Common.Add"
        (clicked)="Scope.AddPaymentSource?.(parentID)"
        [qaTag]="'add-payments-sources'">
        <ng-container label
            i18n="@@CommonPaymentSourcesAddNew">
            Add New
        </ng-container>
    </lib-button>
</ng-template>

<ng-template #paymentSourceTemplate [type]="PaymentSourceDisplayItem" let-paymentSource>
    <div  class="d-flex flex-column">
        <div class="d-flex align-items-center gap-1 flex-wrap">
            <lib-icon *ngLet="(paymentSource | paymentSourceIcon) as icon"
                [icon]="icon.Icon"
                [size]="IconSize.ExtraSmall">
            </lib-icon>
            <p class="typography-caption-large typography-semibold base-300" data-clarity-mask="true" [attr.data-sb-qa]="'payment-source-issuer'">{{paymentSource.Issuer}}</p>
            <div class="d-flex align-items-baseline gap-1" [attr.data-sb-qa]="'payment-source-label'">
                @if (paymentSource | method: FindFirstVerifiedSource) {
                    <lib-status-label
                        [kind]="StatusKind.Default">
                        <ng-container label i18n="@@CommonDefault">Default</ng-container>
                    </lib-status-label>
                }
                @if (paymentSource.AutoPay && paymentSource.IsVerified) {
                    <lib-status-label
                        [kind]="StatusKind.Success">
                        <ng-container label i18n="@@CommonPaymentSourcesAutoPayOn">
                            Auto Pay Enabled
                        </ng-container>
                    </lib-status-label>
                }
                @if (!paymentSource.IsVerified) {
                    <lib-status-label
                        [kind]="StatusKind.Danger">
                        <ng-container label i18n="@@CommonPaymentSourcesUnverified">Unverified</ng-container>
                    </lib-status-label>
                }
            </div>
        </div>
        <div class="d-flex align-items-baseline gap-2" [attr.data-sb-qa]="'payment-source-number-and-expiry'">
            <caption class="neutral-900" data-clarity-mask="true">
                {{ paymentSource.DisplayText }}
            </caption>
            @if (paymentSource.Type === PaymentSourceType.CreditCard) {
                <caption class="neutral-900" data-clarity-mask="true">
                    exp {{ paymentSource.ExpiryDate! | method: FormatExpiry }}
                </caption>
            }
        </div>
    </div>
</ng-template>

<ng-template #menuButton let-paymentSource let-i="i">
    <lib-menu-button  menu [prefixIcon]="Icon.Common.MoreVert" [iconOnly]="true"
        [hasCaretSuffix]="false" [kind]="ButtonKind.Neutral">
        @if (paymentSource.IsVerified) {
            <lib-menu-item i18n-label="@@CommonPaymentSourcesMakeDefault"
                label="Make Default" [prefixIcon]="Icon.Common.Check" [disabled]="i === 0"
                (clicked)="MakeDefault(paymentSource)">
            </lib-menu-item>
        }
        @if (!paymentSource.IsVerified) {
            <lib-menu-item i18n-label="@@CommonPaymentSourcesVerify" label="Verify"
                [prefixIcon]="Icon.Common.Check" (clicked)="Verify(paymentSource)">
            </lib-menu-item>
        }
        @if (paymentSource.IsVerified && paymentSource.AutoPay && !Scope.forceAutoPay) {
            <lib-menu-item
                i18n-label="@@CommonPaymentSourcesDisableAutoPay" label="Disable Auto Pay"
                [prefixIcon]="Icon.Common.CloseCircle" (clicked)="ToggleAutoPay(paymentSource, false)">
            </lib-menu-item>
        }
        @if (paymentSource.IsVerified && !paymentSource.AutoPay) {
            <lib-menu-item
                i18n-label="@@CommonPaymentSourcesEnableAutoPay" label="Enable Auto Pay"
                [prefixIcon]="Icon.Common.CheckCircle" (clicked)="ToggleAutoPay(paymentSource, true)">
            </lib-menu-item>
        }
        <lib-menu-item i18n-label="@@CommonPaymentSourcesDelete" label="Delete" [prefixIcon]="Icon.Common.DeleteOutline"
            (clicked)="DeleteItem(paymentSource)">
        </lib-menu-item>
    </lib-menu-button>
</ng-template>